import { required } from 'vuelidate/lib/validators';

export default {
  payload: {
    leaseId: {
      required
    },
    amountTotal: {
      required,
      greaterThanZero: (value) => value > 0
    },
    claimType: {
      required
    }
  }
};;
